import React, { useEffect, useMemo, useRef, useState } from 'react'
import './styles.css'
import api from '../../services/api'

function MercadoPagoButton({ product, label = 'Checkout', className = '' }) {
  const [loading,setLoading]=useState(false)
  const [isFetchingKey, setIsFetchingKey] = useState(true)
  const [publicKey, setPublicKey] = useState(null)
  const [publicKeyError, setPublicKeyError] = useState('')
  const [checkoutError, setCheckoutError] = useState('')
  const mpInstanceRef = useRef(null)

  useEffect(() => {
    let isMounted = true;

    const fetchPublicKey = async () => {
      setIsFetchingKey(true);
      setPublicKeyError('');
      try {
        const { data } = await api.get('/mercadopago/public-key');
        const key = data?.publicKey || data?.key || data;
        if (isMounted) {
          setPublicKey(key);
        }
      } catch (error) {
        if (!isMounted) return;
        if (error.response?.status === 404) {
          setPublicKeyError('Configurar Mercado Pago en admin');
        } else {
          setPublicKeyError('No se pudo cargar Mercado Pago');
        }
      } finally {
        if (isMounted) {
          setIsFetchingKey(false);
        }
      }
    };

    fetchPublicKey();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!publicKey || publicKeyError || !window?.MercadoPago) {
      return;
    }

    if (!mpInstanceRef.current) {
      mpInstanceRef.current = new window.MercadoPago(publicKey, { locale: 'es-AR' });
    }
  }, [publicKey, publicKeyError]);

  const checkoutPayload = useMemo(() => {
    if (!product) {
      return null;
    }

    if (Array.isArray(product.items) && product.items.length > 0) {
      return {
        items: product.items.map((item) => ({
          productId: item.id,
          title: item.title,
          quantity: Number(item.quantity) || 1,
          unitPrice: Number(item.price) || 0,
          currencyId: item.currency || product.currency || 'ARS',
          description: item.description,
          pictureUrl: item.pictureUrl
        }))
      };
    }

    return {
      items: [
        {
          productId: product.id,
          title: product.title || 'Producto',
          quantity: Number(product.quantity) || 1,
          unitPrice: Number(product.price) || 0,
          currencyId: product.currency || 'ARS',
          description: product.description,
          pictureUrl: product.pictureUrl
        }
      ]
    };
  }, [product]);

  const generateCheckout = async () => {
    if (!checkoutPayload) {
      return;
    }

    setLoading(true)
    setCheckoutError('');
    try {
      const { data } = await api.post('/checkout', checkoutPayload);
      if (data.url) {
        window.location.href = data.url;
      } else {
        setCheckoutError('No se pudo iniciar el pago.');
      }
    } catch (error) {
      const message = error.response?.data?.message || 'No se pudo iniciar el pago.';
      setCheckoutError(message);
    }
    
    setLoading(false)
  }
  // console.log(url,'data')
//  console.log(url,'url')
  return (
    <div className='flex justify-center items-center w-full'>
      {publicKeyError ? (
        <div className='text-xs text-slate-600'>{publicKeyError}</div>
      ) : (
        <div className='w-full'>
          <button
            onClick={generateCheckout}
            disabled={loading || isFetchingKey}
            className={className}
          >
            {loading || isFetchingKey ? 'Cargando...' : label}
          </button>
          {checkoutError && (
            <div className='text-xs text-red-600 mt-2'>{checkoutError}</div>
          )}
        </div>
      )}
    </div>
  )
}

export default MercadoPagoButton